import React from 'react'
import "./style.scss"

function TextError({ label }: { label: string | undefined }) {
  return <span className="text-error">{label}</span>
}

export default React.memo(TextError)
